/**
 * Fichiers produits par le back-office : CSV au format des exports serveur
 * (séparateur « ; », BOM UTF-8 pour Excel, formules neutralisées).
 */
export function celluleCsv(valeur: unknown): string {
  if (valeur === null || valeur === undefined) return '';
  const texte = valeur instanceof Date ? valeur.toISOString() : String(valeur);
  const sur = /^[=+\-@]/.test(texte) ? `'${texte}` : texte;
  return /[",;\n\r]/.test(sur) ? `"${sur.replace(/"/g, '""')}"` : sur;
}

export function csv(lignes: unknown[][]): Blob {
  const texte = `﻿${lignes.map((l) => l.map(celluleCsv).join(';')).join('\r\n')}\r\n`;
  return new Blob([texte], { type: 'text/csv;charset=utf-8' });
}

/** Propose le fichier au téléchargement. */
export function enregistrer(fichier: Blob, nom: string): void {
  const url = URL.createObjectURL(fichier);
  const lien = document.createElement('a');
  lien.href = url;
  lien.download = nom;
  document.body.appendChild(lien);
  lien.click();
  lien.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** « eleves-2026-09-29.csv » */
export function nomDate(prefixe: string, extension = 'csv'): string {
  return `${prefixe}-${new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris' }).format(new Date())}.${extension}`;
}

/** Identifiant d'opération pour les actions idempotentes (un double clic ne compte qu'une fois). */
export function nouvelleCle(): string {
  return typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
